import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { ListOfPropertiesValues } from "./ListOfPropertiesValues";
import { GENERAL_RULES_CONSTANTS } from "@/modules/GeneralRules/constants/GeneralRulesConstants";

export class MedicalAppointmentValues extends ListOfPropertiesValues {
  patient = this.getPatients;
  doctor = this.getDoctors;
  createdBy = this.getPatients;
  lastDocId = "";
  keyword = "";
  indexSectionOfDashboard = 0;
  indexCollection = 0;

  async loadItems(
    field: string,
    idList?: string,
    keyWord?: string,
    lastDocId?: string
  ) {
    this.lastDocId = lastDocId || "";
    if (keyWord) {
      return (await this[field as keyof MedicalAppointmentValues](
        keyWord
      )) as DynamicSelectData[];
    }

    if (this.keyword) {
      this.keyword = "";
    }

    if (idList) {
      return this.getList(idList);
    }

    return await this[field as keyof MedicalAppointmentValues]();
  }

  findCups() {
    return this.getCups();
  }

  setIndexes(
    indexSectionOfDashboard: number,
    indexCollectionFilter: number
  ): void {
    this.indexSectionOfDashboard = indexSectionOfDashboard;
    this.indexCollection = indexCollectionFilter;
  }

  async getPatients(name?: string) {
    return await this.getUserByQuery(this.setFilters.bind(this), name);
  }

  async getDoctors(name?: string) {
    return await this.getUserByQuery(this.setFilters.bind(this), name);
  }

  setFilters(keyLastRef: string, name?: string) {
    const filterQuery: any = {
      state: GENERAL_RULES_CONSTANTS.ACTIVO
    };

    if (name && this.keyword !== name) {
      this.keyword = name;
      filterQuery.name = name;
      delete filterQuery[keyLastRef];
      return filterQuery;
    }

    if (name) {
      filterQuery.name = name;
      if (this.keyword !== name) {
        this.keyword = name;
      }
      return filterQuery;
    }

    return filterQuery;
  }
}
